import App from './ui/App.svelte';
const app = new App({
  target: document.getElementById('app')
});

export default app;
